<template>
  <v-dialog v-model="dialog" persistent max-width="290">
    <v-card>
      <v-card-title class="headline red" style="color: white">Удаление записи</v-card-title>
      <v-card-text
        >Это действие безвозвратно, вы уверены что хотите удалить запись?
        <div v-show="title || dialog">
          <strong>{{ title }}</strong
          ><br />{{ description }}
        </div>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="green darken-1" text @click="cancel">Нет</v-btn>
        <v-btn color="error" text @click="remove">Да!</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'DeleteDialog',
  props: {
    active: { type: Boolean, required: true },
    title: { type: String, default: '' },
    description: { type: String, default: '' },
  },
  data() {
    return {
      dialog: false,
    }
  },
  watch: {
    active(v) {
      this.dialog = v
    },
  },
  methods: {
    remove() {
      this.$emit('remove')
    },
    cancel() {
      this.$emit('cancel')
    },
  },
}
</script>
